/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2023
 */
import BaseObject from "@shared/BaseObject.js";
import {isObject} from "@/utils/helpers.js";
import {classToClass} from "@qwoach/class-transformer-wrapper";

export default class AccessRules extends BaseObject {

	//ownerId1: AccessRuleItem{myIdForOwner: "clientId", roles: [roles], customPermissions: [], clearanceLevel: 'PHI'}
	//ownerId2: AccessRuleItem{myIdForOwner: "memberId", roles: [roles], customPermissions: ['client_scope_all'], clearanceLevel: 'STANDARD'};
	//...etc

	//Notes:
	//  myIdForOwner - is the id of BaseProfile (ClientProfile ot TeamMemberProfile) in the owner's account that refers back to this user's UserProfile
	//  clearanceLevel - specifies what level of access this user has to the owner's resources.  It can be 'PHI' (PHI+STANDARD) or 'STANDARD'

	constructor() {
		super();
	}

	setAccessRuleFor(ownerId, accessRuleItem){
		let data = this[ownerId] || {}
		accessRuleItem = classToClass(accessRuleItem) //copy to make sure we don't make any changes to the original object
		this._mergeRulesInternal(data, accessRuleItem)
		this[ownerId] = data
	}

	removeAccessRuleFor(ownerId, accessRuleItem){
		let data = this[ownerId] || {roles: []}
		if(accessRuleItem){
			data.roles = data.roles.diffLeft(accessRuleItem.roles)
		}
		if(data.roles.length === 0 || !accessRuleItem){
			delete this[ownerId]
		}
	}



	getMergedAccessRulesFor(ownerId, accessRuleItemProp){
		console.log("AccessRulesIndex: getMergedAccessRulesFor before", this, ownerId)
		let accessRuleItem = Object.assign({}, accessRuleItemProp)
		Object.keys(this).forEach(key => {
			console.log("AccessRulesIndex: key = ", key, this[key])
			let accessRuleLocal = this[key].accessRuleItem
			this._mergeRulesInternal(accessRuleItem, accessRuleLocal)
		})
		console.log("AccessRulesIndex: getMergedAccessRulesFor after = ", accessRuleItem)
		return accessRuleItem
	}

	_mergeRulesInternal(left, right){
		console.log("AccessRulesIndex: _mergeRulesInternal: ", left, right)
		Object.keys(right).forEach(key => {
			if(key === "scopes"){
				left[key] = this._mergeScopesInternal(left[key], right[key])
			} else if (key === "accessLevel"){
				left[key] = this._mergeAccessLevelInternal(left[key], right[key])
			} else if (left[key] === undefined) {
				left[key] = right[key]
			} else {
				if (Array.isArray(left[key])) {
					left[key] = [... new Set([...left[key], ...right[key]])]
				} else if(isObject(left[key])){
					this._mergeRulesInternal(left[key], right[key])
				}
			}
		})
	}

	_mergeScopesInternal(left, right){
		return this._mergeComparableEnums(left, right, (leftValue = 0, rightValue = 0) => {
			let leftRes = leftValue
			let rightRes = rightValue
			console.log("AccessRulesIndex: _mergeScopesInternal", leftRes, rightRes)
			return rightRes - leftRes
		})
	}
	_mergeAccessLevelInternal(left = 0, right = 0){
		let res = right - left
		return res > 0 ? right : left
	}

	_mergeComparableEnums(left, right, callback){
		if(left == null || right == null){
			return left || right
		}
		let mergedKeys = {...left, ...right}
		let keysArray = [...new Set(Object.keys(mergedKeys))]//deduplicate keys
		let result = {}
		for(let key of keysArray){
			let leftValue = left[key]
			let rightValue = right[key]
			let res = callback(leftValue, rightValue)
			let resVal = res > 0 ? rightValue : leftValue
			result[key] = resVal
		}
		console.log("AccessRulesIndex: _mergeScopesInternal", left, right, result)
		return result
	}

}
